<template>
    <div>
        <h1>Hola</h1>

        <button :class="{active: active}" @click="go()">ON</button>
        <button :class="{active: !active}" @click="go()">OFF</button>
    </div>
</template>

<script>
    // import { mapActions } from 'vuex';

    export default {
        data(){
            return {
                active: false,
            }
        },
        methods: {
            // ...mapActions([
            //     'logout'
            // ]),

            go(e){
                // e.stopPropagation();

                this.active = !this.active;
            }
        },
    }
</script>

<style lang="scss" scoped>

    .active {
        background: red !important;
    }
</style>